import { ChangeType } from "@zapier/checkout/esm/types";
import { getChangeLabel } from "../getChangeLabel";

export const getChangeLabelForPlanName = (
  changeType: ChangeType,
  planName: string,
  isRebrand?: boolean
): string => {
  const changeLabel = getChangeLabel(changeType);

  if (changeType === "change") {
    return isRebrand
      ? `${changeLabel} billing for ${planName} plan`
      : `${changeLabel} Billing for ${planName} Plan`;
  }

  return isRebrand
    ? `${changeLabel} to ${planName} plan`
    : `${changeLabel} to ${planName} Plan`;
};
